var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pageState
    ? _c(
        "div",
        { staticClass: "list-container" },
        [
          _vm.showExportReservations
            ? _c("ModalExportReservations", {
                attrs: {
                  showModal: _vm.showExportReservations,
                  onClickCancel: _vm.hideModal,
                  searchTerm: _vm.pageState.searchTerm,
                  meetingtypeId: _vm.selectedMeetingtype,
                  voucherId: _vm.voucherId,
                },
              })
            : _vm._e(),
          _vm.showSideDrawer
            ? _c("ui-component-drawer", {
                attrs: {
                  drawerTitle: _vm.drawerTitle,
                  showDrawer: _vm.showSideDrawer,
                  onClickClose: _vm.hideDrawer,
                  drawerSize: _vm.drawerSize,
                  position: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _vm.showCompanySummary
                            ? _c("CompanySummary", {
                                attrs: {
                                  companyId: _vm.itemId,
                                  locationId: _vm.locationId,
                                },
                              })
                            : _vm._e(),
                          _vm.showReservationSummary
                            ? _c("ReservationSummary", {
                                attrs: {
                                  reservationKey: _vm.itemId,
                                  locationId: _vm.locationId,
                                },
                              })
                            : _vm._e(),
                          _vm.showCustomerSummary
                            ? _c("CustomerSummary", {
                                attrs: {
                                  customerId: _vm.itemId,
                                  locationId: _vm.locationId,
                                },
                              })
                            : _vm._e(),
                          _vm.showProposalPreview
                            ? _c("ProposalDetail", {
                                staticClass: "proposalDetail",
                                attrs: {
                                  proposalKey: _vm.selectedProposalKey,
                                  isEmployee: true,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4199480037
                ),
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "filter-column" },
            [
              _c("ui-search-form", {
                attrs: {
                  dateMode: "range",
                  searchTermPlaceholder: _vm.$t(
                    "Components.Reservation.ReservationList.Placeholder_Search"
                  ),
                  isLoading: _vm.isSearching,
                  useDateInput: _vm.pageState.useDateInput,
                  startDate: _vm.pageState.startDate,
                  endDate: _vm.pageState.endDate,
                  secondStatusId: _vm.pageState.channelId,
                  secondStatusOptions: _vm.channels,
                  actionSearch: _vm.searchReservations,
                },
              }),
            ],
            1
          ),
          _vm.locationId > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "has-margin-top is-hidden-print actionBar has-background-white-ter p-4",
                },
                [
                  _c("div", { staticClass: "level is-mobile" }, [
                    _c("div", { staticClass: "level-left" }),
                    _c("div", { staticClass: "level-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "has-icon has-text-link is-unselectable",
                          on: {
                            click: function ($event) {
                              return _vm.downloadAsPdf()
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "icon",
                              class: { "is-loading": _vm.isCreatingPdf },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "file-download"] },
                              }),
                            ],
                            1
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Components.Reservation.ReservationList.Link_ExportPdf"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "has-icon has-text-link is-unselectable",
                          on: { click: _vm.setShowExportReservations },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "icon is-small",
                              class: { "is-loading": _vm.isCreatingCsv },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "file-download"] },
                              }),
                            ],
                            1
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Components.Reservation.ReservationList.Link_ExportCsv"
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          !_vm.isMobile &&
          _vm.pageState &&
          _vm.pageState.statusses &&
          _vm.pageState.statusses.length > 0 &&
          _vm.pageState.selectedStatus
            ? _c("div", { staticClass: "tabs is-boxed has-margin-top" }, [
                _c(
                  "ul",
                  _vm._l(_vm.pageState.statusses, function (status, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        class: {
                          "is-active":
                            status.status ===
                            _vm.pageState.selectedStatus.status,
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setSelectedStatus(status.status)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ReservationStatus.status_" + status.status
                                )
                              ) +
                                " (" +
                                _vm._s(status.count) +
                                ")"
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _c("div", { staticClass: "select is-fullwidth my-4" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedStatusId,
                        expression: "selectedStatusId",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedStatusId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.pageState.statusses, function (status, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: status.status } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "ReservationStatus.status_" + status.status
                              )
                            ) +
                            " (" +
                            _vm._s(status.count) +
                            ") "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
          _c("div", { staticClass: "list-wrapper" }, [
            _c(
              "div",
              {},
              [
                _c(
                  "table",
                  { staticClass: "table is-fullwidth is-striped is-hoverable" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { attrs: { width: "125px" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Components.Reservation.ReservationList.Label_ReservationId"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("th", { attrs: { width: "125px" } }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Components.Reservation.ReservationList.Label_Date"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("th", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "Components.Reservation.ReservationList.Label_Name"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _vm.locationId === 0
                          ? _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Components.Reservation.ReservationList.Label_Channel"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.locationId === 0
                          ? _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Components.Reservation.ReservationList.Label_Location"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.showBooker
                          ? _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Components.Reservation.ReservationList.Label_Booker"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.locationId > 0
                          ? _c("th", { attrs: { width: "25px" } }, [
                              _vm._v(" "),
                            ])
                          : _vm._e(),
                        _vm.locationId > 0
                          ? _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Components.Reservation.ReservationList.Label_Source"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _c("th", [_vm._v("Tags")]),
                        _c("th", { attrs: { width: "75" } }, [_vm._v(" ")]),
                      ]),
                    ]),
                    _vm.pageState &&
                    _vm.pageState.selectedStatus &&
                    _vm.pageState.selectedStatus.response &&
                    _vm.pageState.selectedStatus.response.Results &&
                    _vm.pageState.selectedStatus.response.Results.length > 0
                      ? _c(
                          "transition-group",
                          {
                            attrs: {
                              name: "staggered-fade",
                              css: false,
                              tag: "tbody",
                            },
                            on: {
                              "before-enter": _vm.beforeEnter,
                              enter: _vm.enter,
                            },
                          },
                          _vm._l(
                            _vm.pageState.selectedStatus.response.Results,
                            function (reservation, index) {
                              return _c(
                                "tr",
                                {
                                  key: "tr_" + index,
                                  attrs: { "data-index": index },
                                },
                                [
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.setShowReservationSummary(
                                              reservation.Key
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("#" + _vm._s(reservation.Id))]
                                    ),
                                    _c("br"),
                                    _c("span", { staticClass: "is-size-7" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ReservationStatus.status_" +
                                              reservation.Status
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("td", { attrs: { nowrap: "" } }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("customDateFormat")(
                                            _vm._f("parseIsoDateStringToDate")(
                                              reservation.Date
                                            ),
                                            "dd MMM yy",
                                            _vm.$i18n.locale
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("minutesToTime")(
                                            reservation.StartMinutes
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("minutesToTime")(
                                            reservation.EndMinutes
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      " " + _vm._s(reservation.Name) + " "
                                    ),
                                  ]),
                                  _vm.locationId === 0
                                    ? _c("td", [
                                        _vm._v(_vm._s(reservation.ChannelName)),
                                      ])
                                    : _vm._e(),
                                  _vm.locationId === 0
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(reservation.LocationName)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.showBooker
                                    ? _c("td", [
                                        reservation.CompanyId > 0
                                          ? _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "has-icon has-text-link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setShowCompanySummary(
                                                        reservation.CompanyId
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "icon is-small",
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: [
                                                            "fas",
                                                            "building",
                                                          ],
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        reservation.CompanyName
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        reservation.CustomerId > 0
                                          ? _c("div", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "has-icon has-text-link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setShowCustomerSummary(
                                                        reservation.CustomerId
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "icon is-small",
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: ["fas", "user"],
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        reservation.CustomerName
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                  _vm.locationId > 0
                                    ? _c(
                                        "td",
                                        {
                                          staticClass: "has-text-right",
                                          attrs: { width: "25px" },
                                        },
                                        [
                                          reservation.InstantBooking
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "icon has-text-warning",
                                                  attrs: {
                                                    title: "InstantBooking",
                                                  },
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: ["fas", "bolt"],
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.locationId > 0
                                    ? _c("td", [
                                        _vm._v(
                                          " " +
                                            _vm._s(reservation.ChannelName) +
                                            " " +
                                            _vm._s(reservation.LeadName) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "td",
                                    [
                                      reservation.Tags.length > 0
                                        ? _c("Tags", {
                                            attrs: {
                                              tags: reservation.Tags.split(","),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("td", [
                                    _c(
                                      "div",
                                      { staticClass: "field is-grouped" },
                                      [
                                        !_vm.isEmployee
                                          ? _c(
                                              "p",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "is-small",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setShowReservationSummary(
                                                          reservation.Key
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "icon" },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "share",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isEmployee
                                          ? _c(
                                              "p",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "is-small",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "Components.Reservation.ReservationList.Link_EditReservation"
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.goToReservation(
                                                          reservation
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "icon" },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "edit",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        reservation.ProposalKey
                                          ? _c(
                                              "p",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "is-small",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "Components.Reservation.ReservationList.Link_PreviewProposal"
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setShowProposalPreview(
                                                          reservation.ProposalKey
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "icon" },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "file-invoice",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [
                    !_vm.isSearching &&
                    _vm.pageState &&
                    _vm.pageState.selectedStatus &&
                    _vm.pageState.selectedStatus.response &&
                    _vm.pageState.selectedStatus.response.Results &&
                    _vm.pageState.selectedStatus.response.Results.length === 0
                      ? _c("Message", {
                          attrs: {
                            message: _vm.$t(
                              "Components.Reservation.ReservationList.Message_NoReservations"
                            ),
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [_vm.isSearching ? _c("ui-loader") : _vm._e()],
                  1
                ),
                !_vm.isSearching
                  ? _c(
                      "div",
                      [
                        _vm.pageState.selectedStatus &&
                        _vm.pageState.selectedStatus.response &&
                        (_vm.pageState.selectedStatus.response.MorePages > 0 ||
                          _vm.pageState.selectedStatus.page > 1)
                          ? _c("Pagination", {
                              attrs: {
                                currentPage: _vm.pageState.selectedStatus.page
                                  ? _vm.pageState.selectedStatus.page
                                  : 1,
                                morePages:
                                  _vm.pageState.selectedStatus.response
                                    .MorePages,
                              },
                              on: { pageSelected: _vm.pageSelected },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }